import * as yup from 'yup';

export const createFormSchemas = (t) => {
  const senhaRegex =
    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()+_\-.,?":{}|<>])[A-Za-z\d!@#$%^&*()+_\-.,?":{}|<>]{8,15}$/;

  const formSchemaCadastro = yup.object().shape({
    maeDesconhecida: yup.boolean().notRequired(),
    cpf: yup
      .string()
      .typeError(t('cadastro.messages.validation.invalid_cpf'))
      .required(t('cadastro.messages.validation.invalid_cpf')),
    nome: yup
      .string()
      .typeError(t('cadastro.messages.validation.name_required'))
      .required(t('cadastro.messages.validation.name_required')),
    nomeDaMae: yup.string().when('maeDesconhecida', {
      is: false,
      then: yup
        .string()
        .typeError(t('cadastro.messages.validation.mothers_name_required'))
        .required(t('cadastro.messages.validation.mothers_name_required')),
      otherwise: yup.string().notRequired(),
    }),
    dataNascimento: yup
      .date()
      .typeError(t('cadastro.messages.validation.birth_date_required'))
      .required(t('cadastro.messages.validation.birth_date_required'))
      .max(new Date(), t('cadastro.messages.validation.birth_date_future'))
        .test('maiorIdade', t('cadastro.messages.validation.minimum_age'), function (value) {
        const dataNascimento = new Date(value);
        const diferenca = new Date() - dataNascimento;
        const idade = Math.floor(diferenca / (1000 * 60 * 60 * 24 * 365));
        return idade >= 18;
      }),
    dddMovel: yup
      .string()
      .typeError(t('cadastro.messages.validation.ddd_required'))
      .required(t('cadastro.messages.validation.ddd_required')),
    foneMovel: yup
      .string()
      .typeError(t('cadastro.messages.validation.phone_required'))
      .required(t('cadastro.messages.validation.phone_required'))
      .test(
        'fone-movel-br',
        t('cadastro.messages.validation.brazilian_mobile_format'),
        function (value) {
          // Se não tem valor, deixa o required cuidar
          if (!value) return true;
          // Remove caracteres não numéricos
          const digits = value.replace(/\D/g, '');
          // Deve ter 9 dígitos e começar com 9
          return /^9\d{8}$/.test(digits);
        }
      ),
    email: yup
      .string()
      .typeError(t('cadastro.messages.validation.email_required'))
      .required(t('cadastro.messages.validation.email_required'))
      .email(t('cadastro.messages.validation.invalid_email')),
    senha: yup
      .string()
      .typeError(t('cadastro.messages.validation.password_required'))
      .required(t('cadastro.messages.validation.password_required'))
      .test(
        'no-slashes',
        t('cadastro.messages.validation.password_no_slashes'),
        (value) => {
          if (!value) return true;
          return !value.includes('/') && !value.includes('\\');
        },
      )
      .matches(senhaRegex, t('cadastro.messages.validation.password_match')),
    confirmaSenha: yup
      .string()
      .typeError(t('cadastro.messages.validation.confirm_password_required'))
      .required(t('cadastro.messages.validation.confirm_password_required'))
      .oneOf(
        [yup.ref('senha'), null],
        t('cadastro.messages.validation.passwords_must_match'),
      ),
  });

  const formSchemaCadastroEstrangeiro = yup.object().shape({
    tenhoCpf: yup.string().notRequired(),
    maeDesconhecida: yup.boolean().notRequired(),
    nome: yup
      .string()
      .typeError(t('cadastro.messages.validation.name_required'))
      .required(t('cadastro.messages.validation.name_required')),
    nomeDaMae: yup.string().when(['tenhoCpf', 'maeDesconhecida'], {
      is: (tenhoCpf, maeDesconhecida) =>
        tenhoCpf === '1' && maeDesconhecida === false,
      then: yup
        .string()
        .typeError(t('cadastro.messages.validation.mothers_name_required'))
        .required(t('cadastro.messages.validation.mothers_name_required')),
      otherwise: yup.string().notRequired(),
    }),
    inputLogin: yup.string().when('tenhoCpf', {
      is: (val) => val === '0',
      then: yup
        .string()
        .typeError(t('cadastro.messages.validation.user_required'))
        .required(t('cadastro.messages.validation.user_required'))
        .min(10, t('cadastro.messages.validation.user_min_length_cadastro_sem_cpf'))
        .max(15, t('cadastro.messages.validation.user_max_length'))
        .matches(
          /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]+$/,
          t('cadastro.messages.validation.user_must_have_letters_and_numbers'),
        ),
      otherwise: yup.string().notRequired(),
    }),
    identidadePassaporte: yup
      .string()
      .typeError(t('cadastro.messages.validation.passport_required'))
      .required(t('cadastro.messages.validation.passport_required'))
      .max(20, t('cadastro.messages.validation.passport_max_length'))
      .matches(
        /^[A-Za-z0-9]*$/,
        t('cadastro.messages.validation.passport_alphanumeric'),
      ),
    dataNascimento: yup
      .date()
      .typeError(t('cadastro.messages.validation.birth_date_required'))
      .required(t('cadastro.messages.validation.birth_date_required'))
      .max(new Date(), t('cadastro.messages.validation.birth_date_future'))
      .test(
        'maiorIdade',
        t('cadastro.messages.validation.minimum_age'),
        function (value) {
          const dataNascimento = new Date(value);
          const diferenca = new Date() - dataNascimento;
          const idade = Math.floor(diferenca / (1000 * 60 * 60 * 24 * 365));
          return idade >= 18;
        },
      ),
    ddiMovel: yup
      .string()
      .typeError(t('cadastro.messages.validation.ddi_required'))
      .required(t('cadastro.messages.validation.ddi_required')),
    dddMovel: yup
      .string()
      .test(
        'ddd-required-brazil',
        t('cadastro.messages.validation.ddd_required'),
        function (value) {
          // Se é residente no exterior, DDD não é obrigatório
          if (this.parent.residencia === '0') {
            return true;
          }
          // Se é residente no Brasil, DDD é obrigatório
          return !!value;
        },
      ),
    foneMovel: yup
      .string()
      .typeError(t('cadastro.messages.validation.phone_required'))
      .required(t('cadastro.messages.validation.phone_required'))
      .test(
        'fone-movel-br-estrangeiro',
        t('cadastro.messages.validation.brazilian_mobile_format'),
        function (value) {
          // Se não tem valor, deixa o required cuidar
          if (!value) return true;
          // Só valida se residente no Brasil
          if (this.parent.residencia === '1') {
            const digits = value.replace(/\D/g, '');
            return /^9\d{8}$/.test(digits);
          }
          return true;
        }
      ),
    email: yup
      .string()
      .typeError(t('cadastro.messages.validation.email_required'))
      .required(t('cadastro.messages.validation.email_required'))
      .email(t('cadastro.messages.validation.invalid_email')),
    senha: yup
      .string()
      .typeError(t('cadastro.messages.validation.password_required'))
      .required(t('cadastro.messages.validation.password_required'))
      .test(
        'no-slashes',
        t('cadastro.messages.password_no_slashes'),
        (value) => {
          if (!value) return true;
          return !value.includes('/') && !value.includes('\\');
        },
      )
      .matches(senhaRegex, t('cadastro.messages.validation.password_match')),
    confirmaSenha: yup
      .string()
      .typeError(t('cadastro.messages.validation.confirm_password_required'))
      .required(t('cadastro.messages.validation.confirm_password_required'))
      .oneOf([yup.ref('senha'), null], t('common.password_mismatch')),
  });

  const formSchemaCadastroToken = yup.object().shape({
    confirmarSenha1: yup
      .string()
      .typeError(t('cadastro.messages.validation.token_digit_required'))
      .required(t('cadastro.messages.validation.token_digit_required')),
    confirmarSenha2: yup
      .string()
      .typeError(t('cadastro.messages.validation.token_digit_required'))
      .required(t('cadastro.messages.validation.token_digit_required')),
    confirmarSenha3: yup
      .string()
      .typeError(t('cadastro.messages.validation.token_digit_required'))
      .required(t('cadastro.messages.validation.token_digit_required')),
    confirmarSenha4: yup
      .string()
      .typeError(t('cadastro.messages.validation.token_digit_required'))
      .required(t('cadastro.messages.validation.token_digit_required')),
    confirmarSenha5: yup
      .string()
      .typeError(t('cadastro.messages.validation.token_digit_required'))
      .required(t('cadastro.messages.validation.token_digit_required')),
    confirmarSenha6: yup
      .string()
      .typeError(t('cadastro.messages.validation.token_digit_required'))
      .required(t('cadastro.messages.validation.token_digit_required')),
  });

  const formEsqueciSenha = yup.object().shape({
    tenhoCpf: yup.string().notRequired(),
    maeDesconhecida: yup.boolean().notRequired(),
    idCorreios: yup
      .string()
      .typeError(t('cadastro.messages.validation.login_required'))
      .required(t('cadastro.messages.validation.login_required'))
      .min(8, t('cadastro.messages.validation.login_min_length'))
      .max(15, t('cadastro.messages.validation.login_max_length')),
    nome: yup.string().when('tenhoCpf', {
      is: (tenhoCpf) => tenhoCpf === '1',
      then: yup
        .string()
        .typeError(t('cadastro.messages.validation.name_required'))
        .required(t('cadastro.messages.validation.name_required')),
      otherwise: yup.string().notRequired(),
    }),
    nomeDaMae: yup.string().when(['tenhoCpf', 'maeDesconhecida'], {
      is: (tenhoCpf, maeDesconhecida) =>
        tenhoCpf === '1' && maeDesconhecida === false,
      then: yup
        .string()
        .typeError(t('cadastro.messages.validation.mothers_name_required'))
        .required(t('cadastro.messages.validation.mothers_name_required')),
      otherwise: yup.string().notRequired(),
    }),
    dataNascimento: yup.date().when('tenhoCpf', {
      is: (tenhoCpf) => tenhoCpf === '1',
      then: yup
        .date()
        .typeError(t('cadastro.messages.validation.birth_date_required'))
        .required(t('cadastro.messages.validation.birth_date_required'))
        .max(new Date(), t('cadastro.messages.validation.birth_date_future'))
        .test(
          'maiorIdade',
          t('cadastro.messages.validation.minimum_age'),
          function (value) {
            const dataNascimento = new Date(value);
            const diferenca = new Date() - dataNascimento;
            const idade = Math.floor(diferenca / (1000 * 60 * 60 * 24 * 365));
            return idade >= 18;
          },
        ),
      otherwise: yup.date().notRequired(),
    }),
    novaSenha: yup
      .string()
      .typeError(t('cadastro.messages.validation.new_password_required'))
      .required(t('cadastro.messages.validation.new_password_required'))
      .test(
        'no-slashes',
        t('cadastro.messages.validation.password_no_slashes'),
        (value) => {
          if (!value) return true;
          return !value.includes('/') && !value.includes('\\');
        },
      )
      .matches(senhaRegex, t('cadastro.messages.validation.password_match'))
      .test(
        'diferente-de-senhaAtual',
        t('cadastro.messages.validation.new_password_different'),
        function (value) {
          return value !== this.parent.senhaAtual;
        },
      ),
    confirmaSenha: yup
      .string()
      .typeError(
        t('cadastro.messages.validation.confirm_new_password_required'),
      )
      .required(t('cadastro.messages.validation.confirm_password_required'))
      .oneOf(
        [yup.ref('novaSenha'), null],
        t('cadastro.messages.validation.passwords_must_match'),
      ),
  });

  const formEsqueciSenhaPJ = yup.object().shape({
    tenhoCnpj: yup.string().notRequired(),
    idCorreios: yup
      .string()
      .typeError(t('cadastro.messages.validation.login_required'))
      .required(t('cadastro.messages.validation.login_required'))
      .min(8, t('cadastro.messages.validation.login_min_length'))
      .max(15, t('cadastro.messages.validation.login_max_length')),
    an8: yup.string().when('tenhoCnpj', {
      is: (tenhoCnpj) => tenhoCnpj === '0',
      then: yup
        .string()
        .typeError(t('cadastro.messages.validation.an8_required'))
        .required(t('cadastro.messages.validation.an8_required')),
      otherwise: yup.string().notRequired(),
    }),
    numeroContrato: yup.string().when('tenhoCnpj', {
      is: (tenhoCnpj) => tenhoCnpj === '0',
      then: yup
        .string()
        .typeError(t('cadastro.messages.validation.contract_required'))
        .required(t('cadastro.messages.validation.contract_required')),
      otherwise: yup.string().notRequired(),
    }),
    nome: yup
      .string()
      .typeError(t('cadastro.messages.validation.company_name_required'))
      .required(t('cadastro.messages.validation.company_name_required')),
    nomeFantasia: yup
      .string()
      .max(100, t('cadastro.messages.validation.trade_name_max_length')),      
    cpf: yup.string().when('tenhoCnpj', {
      is: (tenhoCnpj) => tenhoCnpj === '1',
      then: (schema) => schema
        .typeError(t('cadastro.messages.validation.invalid_cpf'))
        .required(t('cadastro.messages.validation.cpf_required')),
      otherwise: yup.string().notRequired(),
    }),
    dataNascimento: yup.date().when('tenhoCnpj', {
      is: (tenhoCnpj) => tenhoCnpj === '1',
      then: (schema) => schema        
        .typeError(t('cadastro.messages.validation.birth_date_required'))
        .required(t('cadastro.messages.validation.birth_date_required'))
        .max(new Date(), t('cadastro.messages.validation.birth_date_future'))
        .test(
          'maiorIdade',
          t('cadastro.messages.validation.minimum_age'),
          function (value) {
            const dataNascimento = new Date(value);
            const diferenca = new Date() - dataNascimento;
            const idade = Math.floor(diferenca / (1000 * 60 * 60 * 24 * 365));
            return idade >= 18;
          },
        ),
       otherwise: (schema) => schema.notRequired(),
    }),
    novaSenha: yup
      .string()
      .typeError(t('cadastro.messages.validation.password_required'))
      .required(t('cadastro.messages.validation.new_password_required'))
      .test(
        'no-slashes',
        t('cadastro.messages.validation.password_no_slashes'),
        (value) => {
          if (!value) return true;
          return !value.includes('/') && !value.includes('\\');
        },
      )
      .matches(senhaRegex, t('cadastro.messages.validation.password_match'))
      .test(
        'diferente-de-senhaAtual',
        t('cadastro.messages.validation.new_password_different'),
        function (value) {
          return value !== this.parent.senhaAtual;
        },
      ),
    confirmaSenha: yup
      .string()
      .typeError(t('cadastro.messages.validation.confirm_password_required'))
      .required(t('cadastro.messages.validation.confirm_password_required'))
      .oneOf(
        [yup.ref('novaSenha'), null],
        t('cadastro.messages.validation.passwords_must_match'),
      ),
  });

  const formEsqueciSenhaPJAN8 = yup.object().shape({
    an8: yup
      .string()
      .typeError(t('cadastro.messages.validation.an8_required'))
      .required(t('cadastro.messages.validation.an8_required')),
    nome: yup
      .string()
      .typeError(t('cadastro.messages.validation.razao_social_required'))
      .required(t('cadastro.messages.validation.razao_social_required')),
    nomeFantasia: yup
      .string()
      .max(100, t('cadastro.messages.validation.trade_name_max_length')),
  });

  const formRedefinirSenha = yup.object().shape({
    novaSenha: yup
      .string()
      .typeError(t('cadastro.messages.validation.password_required'))
      .required(t('cadastro.messages.validation.new_password_required'))
      .test(
        'no-slashes',
        t('cadastro.messages.validation.password_no_slashes'),
        (value) => {
          if (!value) return true;
          return !value.includes('/') && !value.includes('\\');
        },
      )
      .matches(senhaRegex, t('cadastro.messages.validation.password_match'))
      .test(
        'diferente-de-senhaAtual',
        t('cadastro.messages.validation.new_password_different'),
        function (value) {
          return value !== this.parent.senhaAtual;
        },
      ),
    confirmaSenha: yup
      .string()
      .typeError(t('cadastro.messages.validation.confirm_password_required'))
      .required(t('cadastro.messages.validation.confirm_password_required'))
      .oneOf(
        [yup.ref('novaSenha'), null],
        t('cadastro.messages.validation.passwords_must_match'),
      ),
  });

  const formSchemaRecadastramento = yup.object().shape({
    maeDesconhecida: yup.boolean().notRequired(),
    nome: yup
      .string()
      .typeError(t('cadastro.messages.validation.name_required'))
      .required(t('cadastro.messages.validation.name_required')),
    nomeDaMae: yup.string().when('maeDesconhecida', {
      is: false,
      then: yup
        .string()
        .typeError(t('cadastro.messages.validation.mothers_name_required'))
        .required(t('cadastro.messages.validation.mothers_name_required')),
      otherwise: yup.string().notRequired(),
    }),
    dataNascimento: yup
      .date()
      .typeError(t('cadastro.messages.validation.birth_date_typo'))
      .required(t('cadastro.messages.validation.birth_date_typo'))
      .max(new Date(), t('cadastro.messages.validation.birth_date_future'))
      .test(
        'maiorIdade',
        t('cadastro.messages.validation.minimum_age'),
        function (value) {
          const dataNascimento = new Date(value);
          const diferenca = new Date() - dataNascimento;
          const idade = Math.floor(diferenca / (1000 * 60 * 60 * 24 * 365));
          return idade >= 18;
        },
      ),
  });

  const formSchemaCPFData = yup.object().shape({
    cpf: yup
      .string()
      .typeError(t('cadastro.messages.validation.invalid_cpf'))
      .required(t('cadastro.messages.validation.invalid_cpf'))
      .test("cpf-valido", "CPF inválido", value => isValidCPF(value)),
      
    dataNascimento: yup
      .date()
      .typeError(t('cadastro.messages.validation.birth_date_required'))
      .required(t('cadastro.messages.validation.birth_date_required'))
      .max(
        new Date(),
        t('cadastro.messages.validation.birth_date_future')
      ),
  });

  return {
    formSchemaCadastro,
    formSchemaCadastroEstrangeiro,
    formSchemaCadastroToken,
    formEsqueciSenha,
    formEsqueciSenhaPJ,
    formEsqueciSenhaPJAN8,
    formRedefinirSenha,
    formSchemaRecadastramento,
    formSchemaCPFData,
  };

  function isValidCPF(value) {
    if (!value) return false;

    const cpf = value.replace(/\D/g, "");

    if (cpf.length !== 11) return false;

    // Bloqueia sequências iguais
    if (/^(\d)\1{10}$/.test(cpf)) return false;

    let soma = 0;
    let resto;

    // Primeiro dígito verificador
    for (let i = 0; i < 9; i++) {
      soma += parseInt(cpf.charAt(i)) * (10 - i);
    }

    resto = (soma * 10) % 11;

    if (resto === 10) resto = 0;
    if (resto !== parseInt(cpf.charAt(9))) return false;

    soma = 0;

    // Segundo dígito verificador
    for (let i = 0; i < 10; i++) {
      soma += parseInt(cpf.charAt(i)) * (11 - i);
    }

    resto = (soma * 10) % 11;

    if (resto === 10) resto = 0;
    if (resto !== parseInt(cpf.charAt(10))) return false;

    return true;
  }
};

// Backward compatibility exports for direct imports
export const formSchemaCadastro = null;
export const formSchemaCadastroEstrangeiro = null;
export const formSchemaCadastroToken = null;
export const formEsqueciSenha = null;
export const formEsqueciSenhaPJ = null;
export const formEsqueciSenhaPJAN8 = null;
export const formRedefinirSenha = null;
export const formSchemaRecadastramento = null;
export const formSchemaCPFData = null;
